const serviceData = [
  {
    //ServiceCard props
    cardTitle: "Fractional Executive Leadership & Organizational Strategy",
    //ServiceDescription propsServiceDescription props
    serviceTitle: "Achieve high-impact leadership",
    serviceText:
      "We provide fractional executive leadership and guide your strategy for sustainable growth.",
    //Nav props
    serviceLink: "/fractional-executive-leadership-and-organizational-strategy",
    serviceLinkTab: "Leadership and Organizational Strategy",
    //App props
    servicePage: "<FractionalLeadership />",
    //ServicePage props
    // servicePageTitle: "",
    // servicePageImage: "",
    // servicePageImgAlt: "",
    // servicePageText: "",
    // servicePageBullets: "",
  },
  {
    //ServiceCard props
    cardTitle: "Change Management & Culture Transformation",
    //ServiceDescription props
    serviceTitle: "Build a resilient culture",
    serviceText:
      "We help you navigate change and create a culture aligned with your mission and financial goals.",
    //Nav Props
    serviceLink: "/change-management-and-culture-transformation",
    serviceLinkTab: "Change Management and Culture Transformation",
    //App props
    servicePage: "<ChangeManagement/>",
    //ServicePage props
    // servicePageTitle: "",
    // servicePageImage: "",
    // servicePageImgAlt: "",
    // servicePageText: "",
    // servicePageBullets: "",
  },
  {
    //ServiceCard props
    cardTitle: "Leadership Development and People Operations",
    //ServiceDescription props
    serviceTitle: "Empower your leaders and teams",
    serviceText:
      "We support leadership growth, optimize people operations, and strengthen organizational culture.",
    //Nav Props
    serviceLink: "/leadership-development-and-people-operations",
    serviceLinkTab: "Leadership Development and People Operations",
    //App props
    servicePage: "<LeadershipDevelopment />",
    //ServicePage props
    // servicePageTitle: "",
    // servicePageImage: "",
    // servicePageImgAlt: "",
    // servicePageText: "",
    // servicePageBullets: "",
  },
  {
    //ServiceCard props
    cardTitle: "Comprehensive Consulting & Networked Solutions",
    //ServiceDescription props
    serviceTitle: "Access tailored expertise",
    serviceText:
      "We assemble specialized consulting teams to tackle complex challenges and drive your mission forward.",
    //Nav Props
    serviceLink: "/comprehensive-consulting-and-networked-solutions",
    serviceLinkTab: "Comprehensive Consulting & Networked Solutions",
    //App props
    servicePage: "<ComprehensiveConsulting />",
    //ServicePage props
    // servicePageTitle: "",
    // servicePageImage: "",
    // servicePageImgAlt: "",
    // servicePageText: "",
    // servicePageBullets: "",
  },
];

export default serviceData;
